module.exports = __webpack_public_path__ + "img/deliveryInAdjust.9b645f39.png";